import http from './api'

const route = '/contasreceber/'

export default {

    listar: (empresaId, produtorId, mes, ano) => {
        return http.post(route + 'listar_por_chave_mes_ano', {
            empresa_id: empresaId,
            produtor_id: produtorId,
            mes: mes,
            ano: ano,
        })
    },
    listarLaticinios: (chaveativacao) => (
        http.post(route + 'listar_empresas', { chaveativacao: chaveativacao })
    ),
}
